export default "__VITE_ASSET__BFa2x45F__"